import { Tabs, TabsProps } from "antd";
import Heading from "components/Heading/Heading";
import ProjectTypeCodes from "./ProjectTypeCodes/ProjectTypeCodes";
import ProjectStatusCodes from "./ProjectStatusCodes/ProjectStatusCodes";
const onChange = (key: string) => {
  console.log(key);
};

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "اكواد انواع المشروعات / مراكز التكلفه",
    children: <ProjectTypeCodes />,
  },
  {
    key: "2",
    label: "اكواد حالات المشروع ",
    children: <ProjectStatusCodes />,
  },
];

function ProjectsManagementSettings() {
  return (
    <>
      <div className="mb-7">
        <Heading name={"الاعدادات"} />
      </div>
      <Tabs
        defaultActiveKey="1"
        onChange={onChange}
        type="card"
        items={items}
      />
    </>
  );
}

export default ProjectsManagementSettings;
